import { Directory, Filesystem } from "@capacitor/filesystem"
import { Effect } from "effect"
import { Data } from "effect"

export const SaveFile = Effect.fn("SaveFile")((data: string, directory: Directory, path: string) =>
    Effect.tryPromise({
        try: () =>
            Filesystem.writeFile({
                data,
                directory,
                path,
            }),
        catch: (cause) => new SaveFileError({ message: "Failed to save file", cause }),
    }),
)

export class SaveFileError<T> extends Data.TaggedError("SaveFileError")<{
    message: string
    cause: T
}> {}
